import Splitpanes from './Splitpanes';


Splitpanes.install = function(Vue) {
  Vue.component(Splitpanes.name, Splitpanes);
};

export default Splitpanes;
